<div class="container">
    <form [formGroup]="formulario">

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação De</mat-label>
                    <input matInput id="txtCreateIniDt" #txtCreateIniDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_inicial">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateIniDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação Até</mat-label>
                    <input matInput id="txtCreateFinDt" #txtCreateFinDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_final">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateFinDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Safra</mat-label>
                        <mat-select formControlName="safra">
                          <mat-option *ngFor="let item of listSafra" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>

                       </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                    <input matInput name="site_recebimento" formControlName="site_recebimento"
                        maxlength="15" #txtSiteRecebimento id="txtSiteRecebimento" readonly class="InputBlockColor">
                    <i matSuffix class="{{iconDisableField}}"></i>
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                    <mat-hint align="end">{{txtSiteRecebimento.value.length}} / 15</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-3">
            <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                    floatLabel="{{ formFieldFloatLabel }}">
                    <mat-label class="InputLabelColor">Híbrido</mat-label>
                    <mat-select #txtHibrido formControlName="hibrido_rnc_linhagem" disableCenteringOption>
                        <input matInput type="text" class="form-control filterTxt"
                            placeholder="Pesquisar por..."
                            (keyup)="createFilterHibrido($event.target.value)">
                        <mat-option *ngFor="let item of listHibrido" [value]="item.name">{{ item.name |
                            uppercase }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-3">
            <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                    floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Responsável Lançamento</mat-label>
                    <input matInput id="txtRespLancamento" #txtRespLancamento maxlength="40"
                        formControlName="responsavel_lancamento">
                    <mat-hint align="end">{{txtRespLancamento.value.length}} / 40</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-2">
            <div class="col-lg col-md text-right">
                <button mat-flat-button color="primary" matTooltip="Limpar" class="textoGeral mr-1"
                    (click)="clearFilter()"><i class="fa fa-paint-brush" aria-hidden="true"></i> Limpar</button>
                <button mat-flat-button color="primary" matTooltip="Pesquisar" class="textoGeral mr-1"
                    (click)="sendFilter()"><i class="fa fa-search" aria-hidden="true"></i> Pesquisar</button>
            </div>
        </div>
    </form>
</div>
